<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    size?: number | string
    class?: string
  }>(),
  {
    size: 24,
    class: '',
  }
)
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    :class="['lucide lucide-file-search-corner-icon lucide-file-search-corner', props.class]"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.589 3.588A2.4 2.4 0 0 1 20 8v3.25"
    />
    <path d="M14 2v5a1 1 0 0 0 1 1h5" />
    <path d="m21 22-2.88-2.88" />
    <circle cx="16" cy="17" r="3" />
  </svg>
</template>